import { deviceMax } from 'utils/styles/breakpoints';
import styled from 'styled-components/macro';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const ContactInformation = styled.div`
  width: 30%;

  @media only screen and ${deviceMax.laptopLMax} {
    width: 100%;
  }
`;

export const ContactText = styled.div`
  ${FONT_FAMILY.FontMedium}
  ${FONTS.font24}
  color: ${COLORS.mainColor};

  @media only screen and ${deviceMax.desktop} {
    ${FONTS.font16}
  }

  @media only screen and ${deviceMax.laptopLMax} {
    text-align: center;
  }
`;

export const GmailLocationPhone = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn}
  gap: 20px;
  margin-top: 40px;
`;

export const BlockOfCommunicating = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  column-gap: 20px;
  width: 100%;
  height: 20px;

  @media only screen and ${deviceMax.laptopLMax} {
    ${FLEX_CONTAINER.FlexCenterRow}
  }

  @media only screen and ${deviceMax.mobileL} {
    padding-left: 40px;
  }
`;

export const CommunicatingAddressText = styled.div`
  ${FONT_FAMILY.FontRegular}
  ${FONTS.font16}
  color: ${COLORS.mainColor};
  width: 150px;

  @media only screen and ${deviceMax.laptopLMax} {
    width: 150px;
    text-align: left;
    margin-left: 10px;
  }

  @media only screen and ${deviceMax.mobileL} {
    ${FONTS.font12}
  }
`;

export const SocialMediaIcons = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  margin-top: 60px;
  column-gap: 20px;
  width: 100%;

  @media only screen and ${deviceMax.laptopLMax} {
    ${FLEX_CONTAINER.FlexCenterRow}
    margin-bottom: 50px;
  }

  @media only screen and ${deviceMax.tablet} {
    margin-top: 50px;
    margin-bottom: 40px;
  }
`;

export const LinkToWebsite = styled.a``;

export const IconImage = styled.img`
  cursor: pointer;
  
  &:hover {
    filter: brightness(0) saturate(100%) invert(18%) sepia(76%) saturate(593%) hue-rotate(156deg) brightness(97%) contrast(93%);
    opacity: 0.7;
  }
`;

export const IconsForContact = styled.img`
  @media only screen and ${deviceMax.tablet} {
    width: 25px;
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 20px;
  }
`;
